import React from 'react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { RentalAssortment } from '../components/RentalAssortment';
import { RentalSlider } from '../components/RentalSlider';
import { RecentWorks } from '../components/RecentWorks';
import { FeaturedEvents } from '../components/FeaturedEvents';
import { useScreenInit } from '../useScreenInit';
import { motion } from 'framer-motion';
export function LandingPage() {
  useScreenInit();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.8
  }} className="min-h-screen bg-white font-sans selection:bg-[#b22222] selection:text-white" data-id="element-466">
      <TopBar data-id="element-467" />
      <Navbar data-id="element-468" />
      <main data-id="element-469">
        <Hero data-id="element-470" />

        {/* Our Story Section moved here */}
        <section className="py-16 bg-gray-50" data-id="element-471">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-472">
            <div className="max-w-[1440px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-473">
              <div className="relative aspect-[16/10]" data-id="element-474">
                <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop" alt="About Us" className="w-full h-full object-cover shadow-2xl" data-id="element-475" />
                <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-white p-8 shadow-xl hidden md:block" data-id="element-476">
                  <span className="font-script text-5xl text-[#b22222]" data-id="element-477">
                    Chyne
                  </span>
                  <p className="text-[10px] uppercase tracking-widest font-bold text-gray-500 mt-2" data-id="element-478">
                    Defining Elegance Since 2015
                  </p>
                </div>
              </div>
              <div data-id="element-479">
                <span className="text-[12px] uppercase tracking-[0.3em] font-bold text-[#b22222] mb-4 block" data-id="element-480">
                  Our Story
                </span>
                <h2 className="font-serif text-4xl md:text-5xl mb-8 text-gray-900 leading-tight" data-id="element-481">
                  Crafting Unforgettable <br data-id="element-482" />
                  <span className="italic" data-id="element-483">Atmospheres</span>
                </h2>
                <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-484">
                  At Chyne Designs Elegant Events & Rentals LLC, we believe that
                  every event is a canvas waiting to be painted with style and
                  sophistication. Our curated collection of high-end rentals is
                  meticulously selected to ensure your celebration reflects your
                  unique personality and vision.
                </p>
                <Link to="/about-us" data-id="element-485">
                  <button className="border border-black px-8 py-4 text-xs font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-all duration-300" data-id="element-486">
                    Learn More About Us
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <RentalAssortment data-id="element-487" />
        <FeaturedEvents data-id="element-488" />
        <RentalSlider data-id="element-489" />
        <RecentWorks data-id="element-490" />

        {/* Newsletter / Footer CTA */}
        <section className="py-24 bg-black text-white text-center" data-id="element-491">
          <div className="mx-4 md:mx-[4.1rem]" data-id="element-492">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="max-w-4xl mx-auto px-6" data-id="element-493">
              <h2 className="font-serif text-4xl mb-6 italic" data-id="element-494">Stay Inspired</h2>
              <p className="text-gray-400 mb-12 tracking-wide" data-id="element-495">
                Subscribe to our newsletter for the latest trends in event
                design and exclusive rental previews.
              </p>
              <form className="flex flex-col md:flex-row gap-4 max-w-lg mx-auto" data-id="element-496">
                <input type="email" placeholder="YOUR EMAIL ADDRESS" className="flex-1 bg-transparent border-b border-gray-700 py-4 text-sm focus:border-white outline-none transition-colors" data-id="element-497" />
                <button className="bg-white text-black px-8 py-4 text-xs font-bold uppercase tracking-widest hover:bg-[#b22222] hover:text-white transition-colors" data-id="element-498">
                  Subscribe
                </button>
              </form>
            </motion.div>
          </div>
        </section>
      </main>

      <footer className="bg-white py-12 border-t border-gray-100" data-id="element-499">
        <div className="max-w-[1440px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-500">
          <div className="flex flex-col items-center md:items-start leading-none" data-id="element-501">
            <span className="font-script text-3xl text-black" data-id="element-502">
              Chyne Designs
            </span>
            <span className="text-[8px] uppercase tracking-[0.2em] font-bold text-gray-400 mt-1" data-id="element-503">
              Elegant Events & Rentals LLC
            </span>
          </div>
          <div className="flex gap-8 text-[11px] font-bold uppercase tracking-widest text-gray-500" data-id="element-504">
            <a href="#" className="hover:text-black transition-colors" data-id="element-505">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-black transition-colors" data-id="element-506">
              Terms of Service
            </a>
            <a href="#" className="hover:text-black transition-colors" data-id="element-507">
              Contact
            </a>
          </div>
          <p className="text-[11px] text-gray-400" data-id="element-508">
            © 2026 Chyne Designs Elegant Events & Rentals LLC. All rights
            reserved.
          </p>
        </div>
      </footer>
    </motion.div>;
}